// @flow
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { PanelStylesClassesType } from "../../../global/styles/generalStyles";
import { panelStyles, topBanner } from "../../../global/styles/generalStyles";
import ErrorDisplay, {
  setErrorMsg
} from "../../../global/components/ErrorDisplay";
import { StyledBreadcrumb } from "imagus-components";
import FaceUpload from "./FaceUpload";
import FaceDetect from "./FaceDetect";
import FaceIdentify from "./FaceIdentify";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...panelStyles(theme),
  topBanner,
  helpText: {
    color: theme.palette.primary.main,
    width: "100%",
    textAlign: "left",
    fontSize: "0.875rem",
    padding: "5px"
  },
  rightMargin: {
    marginRight: "5px"
  }
});

type FaceSearchTemplateStatesType = {
  step: number,
  errors: DictionaryType
};

type FaceSearchTemplatePropsType = {
  FaceUpload: React$ComponentType<*>,
  FaceDetect: React$ComponentType<*>,
  FaceIdentify: React$ComponentType<*>,
  classes: {
    ...PanelStylesClassesType,
    topBanner: DictionaryType
  }
};

class FaceSearchTemplate extends Component<
  FaceSearchTemplatePropsType,
  FaceSearchTemplateStatesType
> {
  constructor(props: FaceSearchTemplatePropsType) {
    super(props);
    this.state = {
      step: 0,
      errors: {}
    };
  }

  setImageError = (error: string): * => {
    this.setState({ errors: setErrorMsg(this.state.errors, "image", error) });
  };

  setStep = (step: number): * => {
    this.setState({ step: step });
  };

  render(): * {
    const classes = this.props.classes;

    const tabs = [
      {
        label: "Upload",
        component: (
          <div className={classes.appPanel}>
            <FaceUpload
              setImageError={this.setImageError}
              setStep={this.setStep}
            />
          </div>
        )
      },
      {
        label: "Detect",
        component: (
          <div className={classes.appPanel}>
            <FaceDetect
              setImageError={this.setImageError}
              setStep={this.setStep}
            />
          </div>
        )
      },
      {
        label: "Identify",
        component: (
          <div className={classes.appPanel}>
            <FaceIdentify setImageError={this.setImageError} />
          </div>
        )
      }
    ];
    return (
      <div>
        <div className={classes.topBanner}>
          <ErrorDisplay errors={this.state.errors} />
        </div>
        <StyledBreadcrumb tabs={tabs} step={this.state.step} />
      </div>
    );
  }
}

export default withStyles(styles)(FaceSearchTemplate);
